import {t} from "i18next";
import {merge} from "lodash-es";
import {FieldNames} from "models/fields";
import {
  ATTACK_GRAPH_OPTIONS,
  COMBINE_FIELDS,
  RELATIONS_GRAPH_OPTIONS
} from "./graphStyleConstants";

export const DEFAULT_ANNOTATION_COORDS = {x: 0, y: 0};

export const getRelationsGraphOptions = (themeOptions, mode) =>
  merge({}, RELATIONS_GRAPH_OPTIONS, themeOptions, {handMode: mode});

export const getAttackGraphOptions = (themeOptions) =>
  merge({}, ATTACK_GRAPH_OPTIONS, themeOptions);

/**
 * Create a combo's display label
 *
 * @param {Object} groupData Original group data
 * @returns {String} A Combo label
 */
export const getComboLabel = (groupData, combinedOnType) => {
  // Take group label directly in most cases
  let groupLabel = groupData?.label.text;

  // We can assert this to be an Asset Group under these conditions
  // If true, re-map the label to the default label: "Asset Group"
  // (It will most likely be "target" or just undefined from the API)
  if (
    groupLabel === FieldNames.target &&
    (combinedOnType === COMBINE_FIELDS.targetGroup ||
      combinedOnType === COMBINE_FIELDS.observableOfTarget)
  ) {
    groupLabel = `${t(`investigationDetail.graph.assetGroup`)}`;
  }

  return groupLabel;
};

export const getComboType = (groupData) =>
  groupData?.data?.variant || groupData?.data?.type;

/**
 * Reduce the 'combo' object from onCombineNodes to produce a tuple
 * of [combinedOnType, combinedOnKey]
 *
 * combinedOnType = A value of COMBINE_FIELDS
 * combinedOnKey = Data key for the combp (group)
 *
 * @param {Object} combo Combo object from onCombineNodes
 * @returns {Array} Tuple: [comboType, comboValue]
 */
export const getCombinedOnTuple = (combo) => {
  for (const comboField of Object.values(COMBINE_FIELDS)) {
    const firstCombinedOn = Object.entries(combo).find(
      ([key]) => key === comboField
    );
    if (firstCombinedOn) return firstCombinedOn;
  }
};

/**
 * Given a graphModel, determine if it is a Node item.
 *
 * @param {Object} item graphModel item
 * @returns {Boolean} Is item a Node.
 */
export const isNode = (item) => item && !item.id1 && !item.id2;

/**
 * Given a graphModel, determine if it is an Edge item.
 *
 * @param {Object} item graphModel item
 * @returns {Boolean} Is item an Edge.
 */
export const isEdge = (item) => item && item.id1 && item.id2;

/**
 *
 * @param {Object<String, Object>} nodes Node map object
 * @returns {Array<String>} Array of all unique Observable types.
 */
export const getEntityTypes = (nodes) => [
  ...new Set(Object.values(nodes).map((d) => d.data.type))
];
